import { InjectionToken, Provider } from '@angular/core';
import { DeliveryDate, DeliverySlot, DeliveryZone } from '@delivery/const';
import { ActionReducerMap } from '@ngrx/store';
import { StateUtils } from '@spartacus/core';
import { DELIVERY_DATE, DELIVERY_SLOTS, DELIVERY_ZONES, DeliveryState } from '../delivery-state';

export type DeliveryReducers = DeliveryState;

export function getReducers(): ActionReducerMap<DeliveryReducers> {
  return {
    deliverySlots: StateUtils.loaderReducer<DeliverySlot[]>(DELIVERY_SLOTS),
    deliveryZones: StateUtils.entityLoaderReducer<DeliveryZone[]>(DELIVERY_ZONES),
    deliveryDate: StateUtils.loaderReducer<DeliveryDate>(DELIVERY_DATE),
  };
}

export const reducerToken: InjectionToken<ActionReducerMap<DeliveryReducers>> = new InjectionToken<
  ActionReducerMap<DeliveryReducers>
>('DeliveryReducers');

export const reducerProvider: Provider = {
  provide: reducerToken,
  useFactory: getReducers,
};
